import { InputField, pxToRem, pxTovW, theme } from '@geneo2-web/shared-ui';
import {
  Button,
  IconButton,
  Input,
  InputAdornment,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Box, SxProps } from '@mui/system';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { set } from 'video.js/dist/types/tech/middleware';
import { useEffect } from 'react';
interface IProps {
  searchText?: string;
  handleSearchTextChange: (newValue: string) => void;
  handleSearch: (searchText?: string) => void;
  handleClose: () => void;
  rootSx?: SxProps;
}
export const SearchBar = (props: IProps) => {
  const {
    searchText,
    handleSearchTextChange,
    handleSearch,
    handleClose,
    rootSx,
  } = props;
  const isIpadOnly = !useMediaQuery(theme.breakpoints.down('lg'));
  // useEffect(() => {
  //   console.log('searchText', searchText);
  // }, [searchText]);
  return (
    <Box sx={rootSx}>
      <InputField
        variant="outlined"
        value={searchText}
        onChange={(e) =>
          e.target.value === ''
            ? handleClose()
            : handleSearchTextChange(e.target.value)
        }
        onKeyDown={(e) =>
          e.key === 'Enter' && searchText && handleSearch(searchText)
        }
        sx={{
          //   height: { xs: pxToRem(40), md: pxTovW(56), lg: pxTovW(56) },
          padding: '0px',
          //   backgroundColor: '#FFFFFF',
          border: '1px solid #55ACFF',
          // borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
          width: '100%',
          '&.MuiFormControl-root > div': {
            // backgroundColor: 'red',
            padding: '0px',
            height: { xs: pxToRem(40), md: pxTovW(75), lg: pxTovW(56) },
            paddingLeft: { xs: pxToRem(10), md: pxTovW(20) },
            borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
          },
        }}
        InputProps={{
          startAdornment: (searchText === '' || searchText === null) && (
            <InputAdornment position="start">
              <SearchIcon
                fontSize={isIpadOnly ? 'small' : 'large'}
                color="primary"
              />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{ margin: '0px', padding: '0px', width: '30%' }}
            >
              <Button
                onClick={() => {
                  handleClose();
                }}
                // sx={{ cursor: 'pointer' }}
              >
                <CloseIcon
                  fontSize={isIpadOnly ? 'small' : 'large'}
                  color="primary"
                  sx={{
                    display:
                      searchText?.trim() === '' || searchText === null
                        ? 'none'
                        : 'block',
                  }}
                />
              </Button>

              <Button
                onClick={() => {
                  searchText &&
                    searchText.trim() !== '' &&
                    handleSearch(searchText);
                }}
                sx={{
                  width: '100%',
                  height: { xs: pxToRem(40), md: pxTovW(75), lg: pxTovW(56) },
                  borderTopRightRadius: { xs: pxToRem(15), md: pxTovW(15) },
                  borderBottomRightRadius: { xs: pxToRem(15), md: pxTovW(15) },
                  display: 'flex',
                  alignItems: 'center',
                  cursor:
                    searchText && searchText.trim() !== ''
                      ? 'pointer'
                      : 'default',
                  justifyContent: 'center',
                  backgroundColor: '#007CDC',
                  borderRadius: '0',
                  '&:hover': {
                    backgroundColor:
                      searchText && searchText.trim() !== ''
                        ? '#006BB5'
                        : '#007CDC',
                  },
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: 'common.white',
                    fontSize: { xs: pxToRem(14), md: pxTovW(18) },
                  }}
                >
                  Search
                </Typography>
              </Button>
            </InputAdornment>
          ),
        }}
        placeholder="Search"
      />
    </Box>
  );
};
